import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gtm"
export default class extends Controller {
  static values = {
    data: {
      type: Object,
      default: {}
    }
  }

  connect() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(this.dataValue)
  }
}
